import { ServiceType } from "./models/service/servicetype.model";
import { Injectable } from "@angular/core";

@Injectable()
export class ServiceTypeService{
  constructor(){
    
  }
  getListServiceType():ServiceType[]{
    let typeList:ServiceType[]=[];
    typeList.push( new ServiceType(1, 'Topup'));
    typeList.push( new ServiceType(2, 'Mã thẻ'));
    return typeList;
  }

  getListBatchType():ServiceType[]{
    let typeList:ServiceType[]=[];
    typeList.push( new ServiceType(1, 'Mã thẻ'));
    typeList.push( new ServiceType(2, 'Topup'));    
    return typeList;
  }
}